module.exports = __webpack_public_path__ + "img/ClickForSound_3.e385bd13.png";